export default __webpack_public_path__ + "static/media/chat-person.7a59d2f7.svg";